import CountAction from "@/js/plugins/CountAction";
import { countUpAction } from "@/js/helpers";

// 選択中のエリア（市区町村 / 駅 / 学校）のチェックボックスから該当件数を集計して表示する。
//
// 【種別（c-search-type-tabs）とは無関係】2026-08-21 に種別をラジオへ変えたが、
// ここが合算しているのは **[data-pickup-search] 配下のエリアのチェックボックス**で、
// エリアは今も複数選択できる（市区町村を3つ選べば3つ分の合計）。種別タブは
// [data-pickup-search] の外に置かれていて CountAction の走査対象に入らない。
// 種別を変えたときは各ページの *-type-filter.js が件数を取り直してから
// countRecalc を投げ、その新しい data-count をここが集計し直す、という分担
export const setCountAction = () => {
    const pickupRoot = document.querySelector('[data-pickup-search]');
    if (!pickupRoot) return;

    const submitBar = document.querySelector('.c-others-search-submit[data-hide-until-selected]');
    const setSubmitBarVisible = (visible) => {
        if (!submitBar) return;
        submitBar.dataset.visible = visible ? 'true' : 'false';
    };

    const countAction = new CountAction(pickupRoot);
    countAction.on('countChange', (e) => {
        const target = document.querySelector('[data-pickup-count]');
        const lotTarget = document.querySelector('[data-pickup-count-lot]');
        const result = document.querySelector('.p-submit-result');
        // 沿線・駅／学区ページは hide_count で該当数表示自体を出さないため target が無い
        if (target) countUpAction(target, e.count);
        // 分譲地。0でも隠さずそのまま出す（多棟コードを持たない種別は必ず0になる）
        if (lotTarget) countUpAction(lotTarget, e.lotCount);
        if (e.count == 0) {
            if (result) result.dataset.empty = '';
            document.querySelectorAll('.c-others-search-submit .c-buttons-submit').forEach(button => button.setAttribute('disabled', ''));
            setSubmitBarVisible(false);
        } else {
            if (result) delete result.dataset.empty;
            document.querySelectorAll('.c-others-search-submit .c-buttons-submit').forEach(button => button.removeAttribute('disabled'));
            setSubmitBarVisible(true);
        }
    });
}

// pg-header__headline の物件種別部分（例:「新築戸建て」）を、
// 種別ラジオの選択状態に応じてリロードなしで即時更新する。
//
// 【2026-08-21 ラジオ化。設計メモ D25】
// 以前は複数チェックを「、」で連結していた（例:「新築戸建て、土地」）。単一選択に
// なったので連結は起こり得ない。
//
// 【同日 「すべて」タブ（value=all）の撤去に伴い 'all' の判定を削除】
// サーバー側（_header.blade.php）は $types から 'all' を除いて空なら「分譲住宅」を出す。
// これは ?type=all で開いたときの初期表示として今も起こるが、**タブから 'all' を
// 選ぶ手段が無くなった**ので、change 経由でここが 'all' を受け取ることはない。
// 「'all' なら分譲住宅」という分岐は到達不能なので消し、'分譲住宅' は
// ラベルが読めなかったときの保険としてだけ残す
export const setHeadlineTypeSync = () => {
    const tabsRoot = document.querySelector('.c-search-type-tabs[data-mode="radio"]');
    const label = document.querySelector('[data-header-type-label]');
    if (!tabsRoot || !label) return;

    const inputs = [...tabsRoot.querySelectorAll('input[type="radio"]')];

    const update = () => {
        const selected = inputs.find((input) => input.checked);
        const name = selected?.closest('label')?.querySelector('.c-search-type-tabs__main')?.textContent?.trim();
        // 既定種別名へ倒す。サーバ側 pages/search/_header.blade.php も
        // type=all を既定種別として描画するので、両者がここで一致する（2026-08-21）
        label.textContent = name || inputs[0]?.closest('label')?.querySelector('.c-search-type-tabs__main')?.textContent?.trim() || '';
    };

    inputs.forEach((input) => {
        input.addEventListener('change', update);
    });
}
